import type { KPIRequest } from "@/types/kpiTypes.ts"

export const BCOKPIs: KPIRequest[] = [
  {
    $type: "basic",
    id: 10,
    location: 2,
    aggFunction: "Sum",
    padding: 32,
  },
  {
    $type: "basic",
    id: 20,
    location: 2,
    aggFunction: "Sum",
    padding: 32,
  },
  {
    $type: "calc",
    expression: "[10]+[20]",
    location: 2,
    name: "Manure Received",
    aggFunction: "Sum",
    unit: "Gallons",
  },
  {
    $type: "basic",
    id: 45,
    location: 2,
    aggFunction: "Sum",
  },
  {
    $type: "calc",
    location: 2,
    expression: "100 * Max(([45] - ([10] + [20])) / [45], 0)",
    name: "Water Dilution",
    typeId: 1,
    preAggregate: true,
    unit: "%",
    padding: 32,
  },
  {
    $type: "calc",
    name: "Raw Inlet Gas per Minute",
    unit: "SCFM",
    expression: "[60] / 1.44",
    aggFunction: "Average",
    location: 2,
  },
  {
    $type: "basic",
    id: 60,
    location: 2,
  },
  {
    $type: "basic",
    id: 65,
    location: 2,
    padding: 32,
  },
  {
    $type: "basic",
    id: 61,
    location: 2,
  },
  {
    $type: "calc",
    name: "Uptime",
    unit: "%",
    aggFunction: "Average",
    location: 2,
    expression: "[110]/24*100",
    padding: 32,
  },
  {
    $type: "calc",
    name: "Efficiency",
    unit: "%",
    aggFunction: "Average",
    typeId: 1,
    location: 2,
    preAggregate: true,
    expression: "[80] / ([61] * ([110] / 24)) * 100",
    padding: 32,
  },
  { $type: "basic", id: 80, location: 2 },
  { $type: "basic", id: 70, location: 2 },

  {
    $type: "calc",
    expression: "[50] * 0.6 + [55]",
    unit: "MMBtu",
    name: "Gas Flared",
    aggFunction: "Sum",
    location: 2,
  },
  {
    $type: "basic",
    id: 50,
    location: 2,
    padding: 32,
  },
  {
    $type: "basic",
    id: 55,
    location: 2,
    padding: 32,
  },
  {
    $type: "basic",
    id: 110,
    location: 2,
  },
]
